import axios from "axios";

export const api = axios.create({ baseURL: "", timeout: 20000 });

// Safe GET: resolves to `fallback` on any error (404, network, etc.) so pages never crash.
export async function safeGet(url, fallback = null, config) {
  try {
    const { data } = await api.get(url, config);
    return data ?? fallback;
  } catch (e) {
    return fallback;
  }
}

export async function post(url, body = {}) {
  const { data } = await api.post(url, body);
  return data;
}

export async function put(url, body = {}) {
  const { data } = await api.put(url, body);
  return data;
}

export function errorMessage(e, fallback = "Request failed") {
  const d = e?.response?.data;
  if (d && typeof d === "object" && (d.message || d.error)) return d.message || d.error;
  if (e?.response?.status) return `${fallback} (${e.response.status})`;
  return e?.message || fallback;
}

export function resultsRows(data) {
  if (!data) return [];
  if (Array.isArray(data.ranked) && data.ranked.length) return data.ranked;
  return Object.values(data.sectors || {}).flat();
}
